import { Link } from "@tanstack/react-router";
import { Phone, Mail, Info } from "lucide-react";
import logoWhite from "@/assets/schober/logo.webp";
import footerBackground from "@/assets/schober/footer-bg-new.webp";

export function Footer() {
  return (
    <footer className="bg-brand-navy/90 bg-cover bg-center bg-no-repeat text-brand-navy-foreground py-0 md:py-20" style={{ backgroundImage: `linear-gradient(rgba(255, 255, 255, 0.5) 0%, rgba(255, 255, 255, 0.5) 100%), url(${footerBackground})` }}>
      <div className="container mx-auto grid gap-10 px-4 py-14 md:grid-cols-[30%_70%]">
        <div>
          <img
            src={logoWhite}
            alt="Schober Transportservice"
            className="h-15 w-auto"
            width={300}
            height={100}
          />
          <div className="mt-4 h-[2px] w-20 rounded-full bg-black" />
          <ul className="mt-6 space-y-3 text-sm">
            <li className="flex items-center gap-3">
              <Phone className="h-4 w-4 text-black" />
              <a href="tel:00436802308700" className="text-black hover:text-brand-orange">
                +43 680 23 08 700
              </a>
            </li>
            <li className="flex items-center gap-3">
              <Mail className="h-4 w-4 text-black" />
              <a
                href="mailto:office@schober-transportservice.at"
                className="break-all text-black hover:text-brand-orange"
              >
                office@schober-transportservice.at
              </a>
            </li>
          </ul>
        </div>

        <div>
          <h3 className="font-display text-sm font-bold uppercase tracking-[0.2em] text-black">
            Quicklinks
          </h3>
          <ul className="mt-4 space-y-2 text-sm uppercase tracking-wider">
            <li>
              <Link to="/regionen/$region" params={{ region: "industrieviertel" }} className="text-black hover:text-brand-orange">
                Industrieviertel (Wr. Neustadt, Baden, Mödling)
              </Link>
            </li>
            <li>
              <Link to="/regionen/$region" params={{ region: "nordburgenland" }} className="text-black hover:text-brand-orange">
                Nordburgenland (Eisenstadt, Mattersburg)
              </Link>
            </li>
            <li>
              <Link to="/impressum" className="text-black hover:text-brand-orange">
                Impressum
              </Link>
            </li>
            <li>
              <Link to="/datenschutz" className="text-black hover:text-brand-orange">
                Datenschutz
              </Link>
            </li>
            <li>
              <Link to="/sitemap" className="text-black hover:text-brand-orange">
                Sitemap
              </Link>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="container mx-auto px-4 py-4 text-center text-xs text-black/70">
          © {new Date().getFullYear()} Patric Schober | All Rights Reserved
        </div>
      </div>

      <div className="border-t border-white/10 bg-black/5">
        <div className="container mx-auto flex gap-3 px-4 py-4 text-xs leading-relaxed text-black/80">
          <Info className="mt-0.5 h-4 w-4 shrink-0 text-brand-orange" aria-hidden />
          <p>
            <strong>Wichtiger Hinweis:</strong> Schober Transportservice (Inhaber Patric Schober) ist ein{" "}
            <strong>Transportunternehmen</strong> mit der Gewerbeberechtigung „Entrümpler". Wir räumen
            Wohnungen, Häuser, Keller und Gewerbeobjekte und transportieren das Räumgut ab. Die weitere
            Behandlung und Verwertung erfolgt ausschließlich über hierzu befugte Entsorgungsbetriebe – wir
            erbringen keine eigenen abfallwirtschaftlichen Leistungen im Sinne des AWG 2002.
          </p>
        </div>
      </div>
    </footer>
  );
}
